module.exports = {
      id: "fb-blue-usage",
      viewBox: "0 0 28 27.83",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#fb-blue",
      toString: function () {
        return this.url;
      }
    }